import PortalRequestsListView from '../../components/portal/PortalRequestsListView'

const PortalContracts = ({}) => {


    return (
        <>
            <section className='home__query'>
                <div className='home__query__content wrap'>
                    <PortalRequestsListView
                        stageOptions={['Contract requested', 'Contract sent', 'Contract signed', 'Payment initiated', 'Payment received']}
                        />

                    
                </div>
            </section>
        </>
    )


}


export default PortalContracts